import React from 'react';
import { observer } from 'mobx-react';
import { ConceptStore } from '@seedlang/stores';
import autobind from 'autobind-decorator';
import { computed, observable } from 'mobx';
import { isBlank } from '@seedlang/utils';
import { AppUI } from '@seedlang/state';
import Grid from 'components/layout/grid';
import ButtonPrimary from 'components/button/button_primary';

@observer
class WordTagCreate extends React.Component {
  @observable name;
  @observable abbreviation;

  onClick() {
    if (!this.createButtonDisabled) {
      const data = {
        name: this.name,
        abbreviation: this.abbreviation,
        group_id: AppUI.groupId,
        language_id: AppUI.site.languageId,
      };
      ConceptStore.create({data: data}, this.afterCreate);
      this.refs.name.value = '';
      this.refs.abbreviation.value = '';
      this.name = '';
      this.abbreviation = '';
    }
  }

  @autobind afterCreate() {
    this.props.afterChange();
  }

  @computed get createButtonDisabled() {
    return isBlank(this.name) || isBlank(this.abbreviation);
  }

  @autobind onKeyUp(e) {
    if (e.keyCode === 13 && !this.createButtonDisabled) {
      this.onClick();
    }
  }

  render() {
    return (
      <Grid gap='sm' columns={[6,4,1]}>
        <input
          placeholder='Enter Word Tag Name (eg. Imperfect Aspect)'
          ref='name'
          onKeyUp={this.onKeyUp}
          onChange={() => this.name = this.refs.name?.value}
          maxLength={40}
        />
        <input
          placeholder='Enter Word Tag Abbreviation (eg. imp)'
          ref='abbreviation'
          onKeyUp={this.onKeyUp}
          onChange={() => this.abbreviation = this.refs.abbreviation?.value}
          maxLength={10}
        />
        <ButtonPrimary
          disabled={this.createButtonDisabled}
          onClick={this.onClick.bind(this)}
          style={{width: '100%'}}
        >
          Create
        </ButtonPrimary>
      </Grid>
    );
  }
}

export default WordTagCreate;
